interface Environment {
  API_BASE_URL: string;
  APP_NAME: string;
}

const Prodution: Environment = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  APP_NAME: 'OSS Portal',
};

const Development: Environment = {
  API_BASE_URL: 'http://localhost:1337',
  APP_NAME: 'OSS Portal',
};

export default process.env.NODE_ENV === 'production' ? Prodution : Development;
